import { ErrorHandler, NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { GlobalErrorHandler } from './error-handler';

@NgModule({
  declarations: [],
  imports: [
    SharedModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
  ]
})
export class CoreModule { }
